<template>
    <button
        type="button"
        class="btn"
        style="width: 75%"
        :class="buttonClass"
        @click="handleClick"
        :disabled="isDisabled"
    >
        <slot></slot>
    </button>
</template>

<script>
import {signXmlCall} from '../ncalayer/process-ncalayer-calls';
import {unblockScreen} from '../ncalayer/ncalayer.lib';

import {flowState} from './store/flowState';
import {computed} from 'vue';

export default {
    name: 'CommentAttacher',
    props: {
        commentSourceId: {
            type: String,
            required: true,
        },
        commentTargetId: {
            type: String,
            required: true,
        },
        buttonClass: {
            type: String,
            default: 'btn-success',
        },
        skipComment: {
            type: Boolean,
            default: false,
        },
        signWithNcalayer: {
            type: Boolean,
            default: false,
        },
        xml: String,
        keyType: String,
        requiresHead: {
            type: Boolean,
            default: false,
        },
        requiresManager: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const isDisabled = computed(() => {
            if (props.requiresHead && !flowState.headSelected) return true;
            return props.requiresManager && !flowState.managerSelected;
        });
        return {isDisabled};
    },
    methods: {
        handleClick(event) {
            if (this.isDisabled) {
                event.preventDefault();
                return;
            }

            if (!this.skipComment) {
                const sourceElement = document.getElementById(this.commentSourceId);
                const targetElement = document.getElementById(this.commentTargetId);

                if (sourceElement && targetElement) {
                    if (sourceElement.hasAttribute('required') && !sourceElement.value.trim()) {
                        event.preventDefault();
                        sourceElement.classList.add('is-invalid');
                        return false;
                    }

                    sourceElement.classList.remove('is-invalid');
                    targetElement.value = sourceElement.value;
                }
            }

            if (this.signWithNcalayer) {
                this.sign();
                return;
            }

            this.submitForm(null);
        },
        sign() {
            signXmlCall(this.xml, this.keyType, 'PKCS12', (result) => {
                unblockScreen();

                if (result.code === '500') {
                    alert(result.message || 'Некорректная ЭЦП');
                    return;
                }

                this.$emit('xmlReady', result.responseObject);
                this.submitForm(result.responseObject);
            });
        },
        submitForm(xml) {
            const form = this.$el.closest('form');

            if (xml) {
                let xmlInput = form.querySelector('[name="xml"]');
                if (!xmlInput) {
                    xmlInput = document.createElement('input');
                    xmlInput.type = 'hidden';
                    xmlInput.name = 'xml';
                    form.appendChild(xmlInput);
                }
                xmlInput.value = xml;
            }

            form.submit();
        },
    },
};
</script>
